import toArray from 'arrayify';
import BEM from 'bem.js';
import Flatpickr from 'flatpickr';


const BLOCK_DATEPICKER = 'datepicker';


function setUpFlatPickr(node) {
    'use strict';
    let flatpickr = new Flatpickr(node, {
        allowInput: true,
	    altInput: true,
        altFormat: 'd-m-Y',
	    maxDate: new Date(),
    });

    flatpickr.altInput.addEventListener("focusout", function() {
        this.dispatchEvent(new KeyboardEvent('keydown', {
            'keyCode': 13
        }));
    });
}


toArray(BEM.getBEMNodes(BLOCK_DATEPICKER)).forEach(setUpFlatPickr);





// WEBPACK FOOTER //
// ./src/my_artis/js/components/datepicker.js